export function safeJSONParse<T = any>(jsonString: string): T | undefined {
    try {
        return JSON.parse(jsonString) as T;
    } catch (error) {
        if (window.OK.Tracer) {
            window.OK.Tracer.error(error);
        }
    }
}
